export { cards } from '../en/cards';
